export enum PortalContainerIds {
  drawer = 'drawer-container',
}

export const PORTAL_CONTAINER_SELECTORS = {
  drawer: `#${PortalContainerIds.drawer}`,
};

/**
 * С помощью флага initialized защищаемся от повторного добавления корней порталов.
 * Даже если initializePortalContainers вызовется дважды, ничего не поломается
 */
let initialized = false;

const INITIAL_Z_INDEX = 1000000;

export const initializePortalContainers = () => {
  if (initialized) {
    return;
  }

  initialized = true;

  Object.values(PortalContainerIds).forEach((containerId, index) => {
    const container: HTMLDivElement = document.createElement('div');

    container.id = containerId;
    container.style.position = 'fixed';
    container.style.top = '0';
    container.style.left = '0';
    container.style.width = '100%';
    container.style.zIndex = `${INITIAL_Z_INDEX + index}`;

    document.body.appendChild(container);
  });
};
